import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastTimecodeNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 3.59998V5.99998C16.3078 5.99998 19.8 9.49218 19.8 13.8H22.2C22.2 8.17568 17.6243 3.59998 12 3.59998Z"
        fill={color}
      />
      <path
        d="M4.2 13.8H1.8C1.8 19.4243 6.3757 24 12 24V21.6C7.6922 21.6 4.2 18.1078 4.2 13.8Z"
        fill={color}
      />
      <path
        d="M19.8 13.8C19.8 18.1078 16.3078 21.6 12 21.6V24C17.6243 24 22.2 19.4243 22.2 13.8H19.8Z"
        fill={color}
      />
      <path
        d="M1.8 13.8H4.2C4.2 9.49218 7.6922 5.99998 12 5.99998V3.59998C6.3757 3.59998 1.8 8.17568 1.8 13.8Z"
        fill={color}
      />
      <path
        d="M12 12C11.0059 12 10.2 12.8059 10.2 13.8C10.2 14.7941 11.0059 15.6 12 15.6C12.9941 15.6 13.8 14.7941 13.8 13.8C13.8 12.8059 12.9941 12 12 12Z"
        fill={color}
      />
      <path
        d="M15 0H9C8.006 0 7.2 0.8058 7.2 1.8C7.2 2.7942 8.006 3.6 9 3.6H15C15.994 3.6 16.8 2.794 16.8 1.8C16.8 0.806 15.994 0 15 0Z"
        fill={color}
      />
      <path d="M13.8 2.40002H10.2V4.80002H13.8V2.40002Z" fill={color} />
      <path
        d="M16.8 14.7H12C11.5031 14.7 11.1 14.2969 11.1 13.8V8.99998C11.1 8.50308 11.5031 8.09998 12 8.09998C12.4969 8.09998 12.9 8.50308 12.9 8.99998V12.9H16.8C17.2969 12.9 17.7 13.3031 17.7 13.8C17.7 14.2969 17.2969 14.7 16.8 14.7Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastTimecodeNsk.displayName = 'PlayblastTimecodeNsk';
